import {Component, EventEmitter, Input, Output, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import {DatePipe, NgTemplateOutlet} from '@angular/common';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faClockFive, faUser} from '@fortawesome/pro-solid-svg-icons';
import {BicBadgeComponent} from '@buildinginformationcloud/bic-ui-components';
import {ReportRow} from './report-row.model';
import {ReportMyChecksBadgeComponent} from './report-mychecks-badge.component';
import {ReportFilesBadgeComponent} from './report-files-badge.component';

/**
 * Kompakte Karte der kartenbasierten Berichtsübersicht: Titel, Datum, Prüfer*in und ⋮-Menü,
 * darunter myChecks-, Dateien- und Status-Badge. Die ganze Karte öffnet den Bericht – wie eine
 * Tabellenzeile, also auch per Mittelklick in einem neuen Tab; das ⋮-Menü ist davon ausgenommen.
 *
 * Das ⋮-Menü kommt als Template von der Übersicht, damit Tabelle und Karte dieselben Einträge
 * zeigen. Der Prüflauf-Log hat bewusst keinen eigenen Button auf der Karte, er steht im Menü.
 */
@Component({
  selector: 'app-report-card',
  templateUrl: './report-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DatePipe,
    NgTemplateOutlet,
    FaIconComponent,
    BicBadgeComponent,
    ReportMyChecksBadgeComponent,
    ReportFilesBadgeComponent,
  ],
})
export class ReportCardComponent {
  @Input({required: true}) row!: ReportRow;
  /** ⋮-Menü der Übersicht; Kontext `$implicit` = {@link row}. */
  @Input() menu: TemplateRef<{ $implicit: ReportRow }> | null = null;

  /** Klick auf die Karte – das Event wird durchgereicht, damit Mittelklick einen neuen Tab öffnet. */
  @Output() open = new EventEmitter<MouseEvent>();

  protected readonly faClockFive = faClockFive;
  protected readonly faUser = faUser;
}
